import { render, staticRenderFns } from "./OwnerHasDamagesOnTenantPropertiesQuestion.vue?vue&type=template&id=a742eb66&scoped=true"
import script from "./OwnerHasDamagesOnTenantPropertiesQuestion.vue?vue&type=script&lang=ts"
export * from "./OwnerHasDamagesOnTenantPropertiesQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a742eb66",
  null
  
)

export default component.exports